<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12.5951 2.55798c-.1813-.10355-.3864-.15802-.5952-.15802-.2088 0-.4139.05447-.5952.15802l-8.4 4.8c-.22959.13134-.40936.33487-.51134.57893-.10199.24406-.12047.51497-.05259.77062.06788.25566.21833.48172.42795.64304.20962.16132.46667.24886.73118.24901v8.40002c-.31826 0-.62348.1264-.84853.3514-.22504.2251-.35147.5303-.35147.8486 0 .3182.12643.6235.35147.8485.22505.225.53027.3515.84853.3515h16.8c.3183 0 .6235-.1265.8485-.3515.2251-.225.3515-.5303.3515-.8485 0-.3183-.1264-.6235-.3515-.8486-.225-.225-.5302-.3514-.8485-.3514V9.59958c.2645-.00015.5216-.08769.7312-.24901.2096-.16132.3601-.38738.4279-.64304.0679-.25565.0494-.52656-.0526-.77062-.1019-.24406-.2817-.44759-.5113-.57893l-8.4-4.8ZM5.9999 10.8v6h2.4v-6h-2.4Zm4.8 0h2.4v6h-2.4v-6Zm4.8 0v6h2.4v-6h-2.4Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M11.594 2.08619c.2585-.11492.5537-.11492.8122 0l9 4c.4316.19181.6702.65941.5721 1.1214-.098.46199-.5059.79241-.9782.79241h-18c-.47228 0-.88017-.33042-.97822-.79241-.09804-.46199.14051-.92959.57208-1.1214l9.00004-4ZM7.71231 6h8.57559l-4.2878-1.90568L7.71231 6ZM2.0001 10c0-.55228.44771-1 1-1h18c.5523 0 1 .44772 1 1 0 .5523-.4477 1-1 1v9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-18c-.55229 0-1-.4477-1-1s.44771-1 1-1v-9c-.55229 0-1-.4477-1-1Zm3 1v9h14v-9h-14Zm3 2c.55228 0 1 .4477 1 1v3c0 .5523-.44772 1-1 1-.55229 0-1-.4477-1-1v-3c0-.5523.44771-1 1-1Zm4 0c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3c0-.5523.4477-1 1-1Zm4 0c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3c0-.5523.4477-1 1-1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
